<template>
    <div>
        <!-- 月工作情况(时长) -->
        <Echart :options="options" id="bottomLeftChart" height="190px" width="100%"></Echart>
    </div>
</template>

<script>
import Echart from '../../common/echart'
export default {
    data() {
        return {
            options: {},
        };
    },
    components: {
        Echart,
    },
    props: {
        cdata: {
            type: Object,
            default: () => ({})
        },
    },
    watch: {
        cdata: {
            handler(newData) {
                this.options = {
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b}: <br/>{c} ({d}%)"
                    },
                    color: ['#586C8F', '#56CFA3', '#578AF0'],
                    legend: { //图例组件，颜色和名字
                        top: '5%',
                        left: 'center',
                        itemGap: 12, //图例每项之间的间隔
                        itemWidth: 10,
                        itemHeight: 10,
                        icon: 'rect',
                        textStyle: {
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 12,
                        }
                    },
                    graphic: [
                        {
                            type: 'text',
                            left: 'center',
                            top: '43%',
                            style: {
                                text: '平均出车(天)\n', //使用“+”可以使每行文字居中
                                textAlign: 'center',
                                fontFamily: '微软雅黑',
                                fill: '#fff',
                                width: 30,
                                height: 30,
                                fontSize: 12,
                                fontWeight: 600, //文字的粗线
                            },

                        }, {
                            type: 'text',
                            left: 'center',
                            top: '53%',
                            style: {
                                text: newData.avgRunDayMonthly, //使用“+”可以使每行文字居中
                                textAlign: 'center',
                                fontFamily: '微软雅黑',
                                fill: '#fff',
                                width: 30,
                                height: 30,
                                fontSize: 25,
                                fontWeight: 700, //文字的粗线
                            },

                        }
                    ],//此例饼状图为圆环中心文字显示属性，这是一个原生图形元素组件，功能很多
                    series: [{
                        name: '',
                        type: 'pie',
                        clockwise: false, //饼图的扇区是否是顺时针排布
                        minAngle: 20, //最小的扇区角度（0 ~ 360）
                        radius: [40, 60], //饼图的半径
                        avoidLabelOverlap: false, //是否启用防止标签重叠
                        labelLine: {
                            // minTurnAngle: 0,
                            length: 5,
                            length2: 2,
                        },
                        itemStyle: { //图形样式
                            normal: {
                                borderColor: '#ffffff',
                                borderWidth: 2,
                            },
                        },
                        label: { //标签的位置
                            normal: {
                                trigger: 'item',
                                show: true,
                                position: 'outer', //标签的位置
                                formatter: "{c} ",

                                textStyle: {
                                    color: '#fff',
                                }
                            },

                            emphasis: {
                                show: true,
                                textStyle: {
                                    fontWeight: 'bold'
                                }
                            }
                        },
                        data: newData.rateData,
                    }]
                }
            },
            immediate: true,
            deep: true
        },
    },
}
</script>